import React from 'react'
import { Link } from 'react-router-dom'

// image imports
import Logo from '../assests/logo.png'
import Logo1 from '../assests/logo-white.png'

const Header = () => {
  return (
    <div className="header-container d-flex justify-content-around align-items-center w-100">
      <Link to="/">
        <div className="logo-container">
          <img src={Logo1} alt='logo' />
        </div>
      </Link>
        <h1>Numerology Calculator</h1>
    </div>
  )
}

export default Header